import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { ConfigService } from '../core/services/config.service';

@Pipe({
    name: 'intToHex'
})
export class IntToHexPipe implements PipeTransform {
    transform(number: any, args?: any): any {
        if (Number.isInteger(number)) {
            return number.toString(16).toUpperCase();
        }
        return number;
    }
}
